import "./frontend-ytapi.js";

class YoutubeController {
  constructor() {
    this.videos = {};
    this.$wrapper = false;
    this.updateVideoInstances();

    window.luther.eventBus.on("luther:pageContentChange", () => {
      this.updateVideoInstances();
    });
  }

  _guid() {
    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }

  updateVideoInstances() {
    this.$wrapper = jQuery(".youtubevideo:not(.apiready)");

    if (this.$wrapper.length) {
      this.$wrapper.each((i, el) => {
        const ID = this._guid();
        const youtubevideo = new YoutubeVideo(jQuery(el), ID);
        this.videos[ID] = youtubevideo;
      });
    }
  }

  resetAllVideos() {
    for (var videoID in this.videos) {
      this.videos[videoID].reset();
    }
  }
}

class YoutubeVideo {
  constructor($videoWrapper, ID) {
    this.$wrapper = $videoWrapper;
    this.$iframewrapper = $videoWrapper.find(".youtubevideo__iframe");
    this.$thumbnail = $videoWrapper.find(".youtubevideo__thumbnail");
    this.$thumbnailImg = $videoWrapper.find(".youtubevideo__thumbnailimg");
    this.videoID = this.$iframewrapper.attr("data-video-id");
    this.videoQueryObj = this._getQueryObj(
      this.$iframewrapper.attr("data-video-query")
    );
    this.isStarted = false;
    this.isCreated = false;
    if (this.is_touch_device()) {
      this._create();
      this.$thumbnail.addClass("is-touch");
    } else {
      this.$thumbnail.on("click", this._handleThumbnailClick.bind(this));
    }

    // Fallback, falls
    if (this.$thumbnailImg[0].completed) {
      this._checkThubnail();
    }
    this.$thumbnailImg.on("load", (event) => {
      this._checkThubnail();
    });

    // stop videos if modal closed
    window.luther.eventBus.on("luther:modalClosed", () => {
      if (!this.player) return;
      this.player.stopVideo();
    });
  }

  _getQueryObj(querystring) {
    const params = new URLSearchParams(querystring);
    const obj = {};
    for (const key of params.keys()) {
      if (params.getAll(key).length > 1) {
        obj[key] = params.getAll(key);
      } else {
        obj[key] = params.get(key);
      }
    }
    return obj;
  }

  _checkThubnail() {
    if (this.$thumbnailImg[0].naturalHeight <= 90) {
      var path = this.$thumbnailImg.attr("src");
      var altpath = path.replace("maxresdefault.jpg", "0.jpg");
      this.$thumbnailImg.attr("src", altpath);
    }
  }

  is_touch_device() {
    return "ontouchstart" in window;
  }

  _handleThumbnailClick() {
    if (!this.isCreated) {
      this._create();
    } else {
      this.play();
    }
  }

  _create() {
    this.isCreated = true;
    this.$thumbnail.addClass("loading");
    this.$wrapper.addClass("apiready");
    this.player = new YT.Player(this.$iframewrapper[0], {
      videoId: this.videoID.toString(),
      host: "https://www.youtube-nocookie.com",
      playerVars: { rel: 0, ...this.videoQueryObj },
      events: {
        onReady: this._handleOnReady.bind(this),
      },
    });
  }

  _handleOnReady() {
    if (!this.is_touch_device()) {
      this.play();
    }
  }

  play() {
    if (!this.isStarted) {
      this.isStarted = true;
      this.$thumbnail.addClass("hidden");
      this.player.playVideo();
    }
  }

  reset() {
    if (this.isStarted) {
      this.isStarted = false;
      this.$thumbnail.removeClass("hidden");
      this.$thumbnail.removeClass("loading");
      this.player.stopVideo();
    }
  }
}

jQuery(document).ready(function ($) {
  window.luther = window.luther || {};
  if (document.body.classList.contains("wp-admin")) return;
  var i = setInterval(() => {
    if (!!window.YT && !window.luther.YoutubeController) {
      window.luther.YoutubeController = new YoutubeController();
      clearInterval(i);
    }
  });
});
